import { Component, effect, input } from '@angular/core';
import { MatCardAvatar } from '@angular/material/card';
import { MatTooltip } from '@angular/material/tooltip';
import { WHIconENUM } from '@workheld/workheld-shared-lib';
@Component({
  selector: 'w-h-work-object-identity',
  imports: [MatTooltip, MatCardAvatar],
  templateUrl: './w-h-work-object-identity.html',
  styleUrl: './w-h-work-object-identity.scss',
})
export class WHWorkObjectIdentity {
  extId = input<string>('');
  name = input<string>('');
  type = input<string>('');

  public whIconEnum: WHIconENUM;

  constructor() {
    effect(() => {
      if (this.type()) {
        this.whIconEnum = WHIconENUM[this.type() as keyof typeof WHIconENUM];
      }
    });
  }
}
